import { Grid } from "@mui/material";
import AcxMainTextField from "components/UI/AcxMainTextField";
import AcxDialog from "components/UI/Dialog/AcxDialog";
import React, { useEffect } from "react";
import { useCurrentDashboard } from "../../useCurrentDashboard";
import AcxButton from "components/UI/AcxButton";
import { useNavigate } from "react-router";
import { useStore } from "utils/useStore";
import SignalsPageStore from "../../Store/SignalsPageStore";

// Dialog component for duplicating the dashboard
export const DashboardDuplicateDialog = ({
    open,
    setOpen,
}: {
    open: boolean;
    setOpen: (open: boolean) => void;
}) => {
    const currentDashboard = useCurrentDashboard();
    const signalsPageStore = useStore(SignalsPageStore);
    // Default new dashboard title
    const [newDashboardTitle, setNewDashboardTitle] = React.useState(
        `Copy of ${currentDashboard?.title}`,
    );
    const navigate = useNavigate();
    useEffect(() => {
        setNewDashboardTitle(`Copy of ${currentDashboard?.title}`);
    }, [currentDashboard]);

    return (
        <AcxDialog
            isOpen={open}
            onClose={() => {
                setOpen(false);
            }}
            title={"Duplicate Dashboard"}
            subTitle={`Create a copy of this dashboard`}
            dialogContentChildren={
                <Grid container style={{ width: "40vh" }} spacing={2}>
                    <Grid item xs={12}>
                        <AcxMainTextField
                            id="duplicate-or-edit-dashboard-title-input"
                            labelText="Dashboard Name"
                            value={newDashboardTitle}
                            onChange={(e) =>
                                setNewDashboardTitle(e.target.value)
                            }
                            required
                        />
                    </Grid>
                </Grid>
            }
            children={
                <Grid container item xs={6}>
                    <AcxButton
                        fullWidth
                        color="primary"
                        onClick={async () => {
                            if (currentDashboard) {
                                try {
                                    const newDashboard =
                                        await signalsPageStore.duplicateDashboard(
                                            {
                                                id: currentDashboard.id,
                                                title: newDashboardTitle.trim(),
                                            },
                                        );
                                    setOpen(false);
                                    if (newDashboard) {
                                        navigate(
                                            `/app/signals/${newDashboard.route}/${newDashboard.id}`,
                                        );
                                    }
                                } catch (error) {
                                    console.error(
                                        "Failed to duplicate dashboard:",
                                        error,
                                    );
                                }
                            }
                        }}
                        disabled={
                            !newDashboardTitle ||
                            newDashboardTitle.trim() === ""
                        }
                    >
                        {"Duplicate Dashboard"}
                    </AcxButton>
                </Grid>
            }
        />
    );
};
